(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cdc-card-review-summary"] && !Shopify.designMode) return;
  try {
    (() => {
  const baseUrl = 'https://cdn.shopify.com/s/files/1/0995/6094/8019/files/reviews-bucket-{key}.svg';
  const versions = {
    '0':'1786981354','1':'1786981395','2':'1786981405','3':'1786981413','4':'1786981423',
    '5':'1786981433','6':'1786981441','7':'1786981450','8':'1786981461','9':'1786981469',
    'a':'1786981478','b':'1786981490','c':'1786981504','d':'1786981513','e':'1786981522',
    'f':'1786981533','g':'1786981541','h':'1786981549','i':'1786981559','j':'1786981567',
    'k':'1786981576','l':'1786981587','m':'1786981615','n':'1786981624','o':'1786981632',
    'p':'1786981640','q':'1786981650','r':'1786981659','s':'1786981666','t':'1786981673',
    'u':'1786981683','v':'1786981693','w':'1786981707','y':'1786981715'
  };
  const cache = new Map();
  const normalizeSku = (value) => String(value || '').trim().toLowerCase();
  const bucketKey = (sku) => normalizeSku(sku).replace(/[^a-z0-9]/g, '').slice(0, 1);

  async function gunzipBase64(value) {
    if (!('DecompressionStream' in window)) return null;
    const binary = atob(value.trim());
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
    return new Response(stream).text();
  }

  async function loadBucket(key) {
    if (cache.has(key)) return cache.get(key);
    const promise = (async () => {
      const version = versions[key];
      if (!key || !version) return [];
      const response = await fetch(`${baseUrl.replace('{key}', key)}?v=${version}`, { credentials: 'omit' });
      if (!response.ok) return [];
      const svgText = await response.text();
      const svg = new DOMParser().parseFromString(svgText, 'image/svg+xml');
      const metadata = svg.getElementById('cdc-review-data');
      if (!metadata) return [];
      const jsonText = await gunzipBase64(metadata.textContent || '');
      if (!jsonText) return [];
      const payload = JSON.parse(jsonText);
      if (!Array.isArray(payload.columns) || !Array.isArray(payload.rows)) return [];
      const positions = Object.fromEntries(payload.columns.map((column, index) => [column, index]));
      return payload.rows.map((row) => ({ row, positions }));
    })().catch(() => []);
    cache.set(key, promise);
    return promise;
  }

  function setStarFill(element, rating) {
    const numeric = Number.parseFloat(rating);
    if (!element || !Number.isFinite(numeric)) return;
    const percent = Math.max(0, Math.min(100, (numeric / 5) * 100));
    element.style.setProperty('--cdc-card-rating-percent', `${percent}%`);
  }

  async function initializeCard(summary) {
    if (summary.dataset.cdcCardReviewLoaded === 'true') return;
    summary.dataset.cdcCardReviewLoaded = 'true';

    let skus = [];
    try { skus = JSON.parse(summary.dataset.skus || '[]'); } catch (error) { skus = []; }
    const normalizedSkus = new Set(skus.map(normalizeSku).filter(Boolean));
    if (!normalizedSkus.size) return;

    const keys = [...new Set([...normalizedSkus].map(bucketKey).filter(Boolean))];
    const bucketResults = await Promise.all(keys.map(loadBucket));
    const reviews = bucketResults.flat().filter(({ row, positions }) =>
      normalizedSkus.has(normalizeSku(row[positions['Product SKU']]))
    );
    if (!reviews.length) return;

    const ratings = reviews
      .map(({ row, positions }) => Number.parseFloat(row[positions['Rating']]))
      .filter(Number.isFinite);
    if (!ratings.length) return;

    const average = ratings.reduce((total, rating) => total + rating, 0) / ratings.length;
    setStarFill(summary.querySelector('[data-cdc-card-stars]'), average);

    const averageElement = summary.querySelector('[data-cdc-card-average]');
    if (averageElement) averageElement.textContent = average.toFixed(1);
    const countElement = summary.querySelector('[data-cdc-card-count]');
    if (countElement) countElement.textContent = `(${reviews.length})`;

    summary.setAttribute('aria-label', `${average.toFixed(1)} out of 5 from ${reviews.length} reviews`);

    let card = null;
    const previous = summary.previousElementSibling;
    if (previous && previous.matches('product-card')) card = previous;
    if (!card) card = summary.parentElement?.querySelector('product-card:last-of-type') || null;
    const cardContent = card?.querySelector('.cdc-product-card__content') || summary.closest('.cdc-product-card__content');
    const price = cardContent?.querySelector('product-price');
    if (price) price.insertAdjacentElement('beforebegin', summary);

    summary.hidden = false;
  }

  function initializeWithin(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches?.('[data-cdc-card-review]')) initializeCard(root).catch(() => {});
    root.querySelectorAll?.('[data-cdc-card-review]').forEach((summary) => {
      initializeCard(summary).catch(() => {});
    });
  }

  function initializeAll() {
    document.querySelectorAll('[data-cdc-card-review]').forEach((summary) => {
      initializeCard(summary).catch(() => {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:reorder', initializeAll);

  const observer = new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(initializeWithin));
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
